export const getChartTimesList = (t: (text: string) => string) => [
  { value: 1, label: t('1D') },
  { value: 2, label: t('2D') },
  { value: 7, label: t('1W') },
  { value: 14, label: t('2W') },
  { value: 30, label: t('1M') },
  { value: 60, label: t('2M') },
  { value: 90, label: t('3M') },
  { value: 180, label: t('6M') },
];
